import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Segment } from '@calendly/segment';
import { Badge } from '@calendly/ui/components/badge';
import { Button } from '@calendly/ui/components/button';
import { FlexLayout } from '@calendly/ui/components/flex-layout';
import { CheckCircleIcon } from '@calendly/ui/components/icons';
import { TitleText } from '@calendly/ui/components/typography';
import { greyLevel5 } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useGetUserQuery } from 'common';
import { useBillingPath } from 'features/billing';
import { currentOrganizationSelector } from 'selectors/current_organization';
import { BadgeWrapper, Description } from '../styles';
import { SEGMENT_DOMAIN_CONTROL_CONTACT_US_CLICK } from './constants';
import { OnboardingGuideLink } from './shared_components/info_links';
const listHeaderCss = "l1bzicgx";
const ListHeader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(listHeaderCss, props.className)} />;
});
const styledOptionSpanCss = "sibbjrd";
const StyledOptionSpan = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(styledOptionSpanCss, props.className)} />;
});
const optionListItemCss = "o8xk9ye";
const OptionListItem = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'li';
  return <Component ref={ref} {...restProps} className={classNames(optionListItemCss, props.className)} />;
});
const accessOwnerOptionsListCss = "axgith0";
const AccessOwnerOptionsList = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'ul';
  return <Component ref={ref} {...restProps} className={classNames(accessOwnerOptionsListCss, props.className)} />;
});
const domainOptionsListCss = "d1x5joba";
const DomainOptionsList = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'ul';
  return <Component ref={ref} {...restProps} className={classNames(domainOptionsListCss, props.className)} />;
});
export const Paywall = () => {
  const {
    id: organizationId
  } = useSelector(currentOrganizationSelector);
  const {
    data: {
      id: userId
    }
  } = useGetUserQuery();
  const contactSalesPath = useBillingPath('/contact_sales');
  const optionItems = () => [I18n.t('publisher.organization_settings.domain_control.paywall.option_outstanding_accts'), I18n.t('publisher.organization_settings.domain_control.paywall.option_block_employees'), I18n.t('publisher.organization_settings.domain_control.paywall.option_request_access'), I18n.t('publisher.organization_settings.domain_control.paywall.option_access_owner')].map(translationString => <OptionListItem key={translationString}>
      <CheckCircleIcon color={greyLevel5} />
      <StyledOptionSpan>{translationString}</StyledOptionSpan>
    </OptionListItem>);
  const accessOwnerOptions = () => [I18n.t('publisher.organization_settings.domain_control.paywall.access_owner_options.org_member'), I18n.t('publisher.organization_settings.domain_control.paywall.access_owner_options.ext_email'), I18n.t('publisher.organization_settings.domain_control.paywall.access_owner_options.ext_link'), I18n.t('publisher.organization_settings.domain_control.paywall.access_owner_options.deny')].map(translationString => <OptionListItem key={translationString}>{translationString}</OptionListItem>);
  const onContactButtonClick = () => {
    Segment.track(SEGMENT_DOMAIN_CONTROL_CONTACT_US_CLICK, {
      organization_id: organizationId,
      user_id: userId
    });
  };
  return <div>
      <BadgeWrapper>
        <Badge type="new">{I18n.t('publisher.billing.tiers.enterprise')}</Badge>
      </BadgeWrapper>
      <FlexLayout direction="column" gap={16}>
        <TitleText level={2} size="medium">{I18n.t('publisher.organization_settings.domain_control.title')}</TitleText>
        <Description>
          {HtmlParser(I18n.t('publisher.organization_settings.domain_control.description'), {
          OnboardingGuideLink
        })}
        </Description>
      </FlexLayout>
      <Button as={Link} to={contactSalesPath} onClick={onContactButtonClick}>
        {I18n.t('publisher.action.contact_sales')}
      </Button>
      <ListHeader>{I18n.t('publisher.organization_settings.domain_control.paywall.options_list')}</ListHeader>
      <DomainOptionsList>
        {optionItems()}
      </DomainOptionsList>
      <AccessOwnerOptionsList>
        {accessOwnerOptions()}
      </AccessOwnerOptionsList>
    </div>;
};

require("./paywall.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./paywall.js");